import ReaderHelpIcon from 'components/ReaderHelpIcon'

export default function HelpIcon({ text }: { text?: string }) {
  return (
    <ReaderHelpIcon
      text={text}
      builderPath={'/builder/ja-JP/ocr-reader-doc/check-usage.html#Dashboard'}
      concurPath={'/concur/ja-JP/ocr-reader-doc/check-usage.html#Dashboard'}
      invoicePath={'/invoice/ja-JP/ocr-reader-doc/check-usage.html#Dashboard'}
      orderFormPath={'/order-form/ja-JP/ocr-reader-doc/check-usage.html#Dashboard'}
    />
  )
}
